import React from 'react';
import { Grid, Box, useTheme, useMediaQuery } from '@mui/material';

import { dateToLocalString } from '@shared/helpers/flights/reserve';
import FlightTextItem from './FlightTextItem';

function returnTime(time) {
  return time.slice(11, 16);
}

const FlightSegmentSuccess = ({ icon: Icon, date, time, origin, airport }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xl'));

  const iconSize = isMobile
    ? { width: 18, height: 12 }
    : { width: 28, height: 19 };

  return (
    <Grid container alignItems="center" sx={{ mt: '1vh' }}>
      <Grid item xs={1}>
        <Box sx={{ marginRight: '5px' }}>
          {React.cloneElement(Icon, iconSize)}
        </Box>
      </Grid>

      <FlightTextItem xs={3}>{dateToLocalString(date)}</FlightTextItem>
      <FlightTextItem xs={2}>{`${returnTime(time)} hs`}</FlightTextItem>
      <FlightTextItem xs={2}>{origin}</FlightTextItem>
      <FlightTextItem xs={4}>{airport}</FlightTextItem>
    </Grid>
  );
};

export default FlightSegmentSuccess;
